import React from 'react';
import Topfold from './Topfold';
import Header from './Header';
import Services from './Services';
import Footer from './Footer';
import Productline from './Productline';
import Message from './Message';

const HomePage = () => {
    return (
        <div className="home-page">
            <Header variant="marketing" />
            <Topfold />
            <Services />
            <Message />
            <Productline />
            <Footer />
        </div>
    );
};

export default HomePage;
